import fetchApi from './api';
import {ApiResponse, LoginResponse, SearchPaging} from 'models/model';

export const ExamSave = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Exam/Save', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const ExamGetPaging = async (data: SearchPaging): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Exam/GetPaging', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const ExamDelete = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Exam/Delete', {
        method: 'POST',
        body: JSON.stringify({ id })
    });
};

export const ExamCreateAutomatic = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Exam/CreateAutomatic', {
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export const ExamCheck = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Exam/CheckExamExists', {
        method: 'POST',
        body: JSON.stringify({ id })
    });

}